<template>
  <div>
    <show-code :code="fieldInfoList"></show-code>
    <show-code :code="preResult"></show-code>
    <load-block :load="!load"></load-block>
    <the-edit-page
      :scheme="scheme"
      :isEntity="true"
      :loadData="loadData"
      v-if="load"
      :title="title"
      :pageMode="pageMode"
    >
      <the-controls-edit-page
        :scheme="scheme"
        :loadData="loadData"
        :saveData="saveData"
        :pathBack="pathBack"
        :show-history="!($route.name == 'CommercialTermRuleCreate')"
        :open-history="openHistory"
        configName="financialConditionRule"
        :pageMode="pageMode"
        :wait="wait"
        :roleName="nameRoleEntity"
      ></the-controls-edit-page>
    </the-edit-page>
    <!-- <history-code-enum
      v-if="!($route.name == 'PolicyRuleCreate')"
      :modals="modals"
      :toggleModal="toggleModal"
      :closeHistory="closeHistory"
    ></history-code-enum> -->
  </div>
</template>
<script>
import TheEditPage from "../../../TheEditPage.vue";
import { COMMERCIAL_TERMS_RULE } from "../store/type";
import { READ, UPDATE } from "../../../../store/type";
import TheControlsEditPage from "../../../TheControlsEditPage.vue";
import clearReactive from "../../../../helpers/clearReactive";
import ShowCode from "../../../shared/ShowCode.vue";
import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";
import clearNull from "../../../../../src/helpers/clearNull";
import { mapState } from "vuex";

import { TYPE_ERRORS, FIELD_LANG_FINANCIAL_CONDITION_RULE } from "../../../../constant";
import notify from "../../../../helpers/notify/notify";
import LoadBlock from "../../../shared/LoadBlock.vue";

import { checkValidate } from "../../../../mixins/validate/checkValidate";
import HistoryCodeEnum from "../../history/HistoryCodeEnum.vue";
import { pageMode } from "../../../../mixins/editPage/pageMode";
import {NAME_OBJECT} from "../../../../RoleConstanans"
export default {
  name: "EditPageCommercialTermRule",
  components: {
    HistoryCodeEnum,
    LoadBlock,
    ShowCode,
    TheControlsEditPage,
    TheEditPage
  },
  mixins: [checkValidate, pageMode],
  data() {
    return {
      wait: false,
      pathBack: `/commercialTerms/${this.$route.params.FinancialConditionId}/edit`,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,
      modals: {
        history: false
      },
      routeNameShow: "CommercialTermRuleShow",
      routeNameCreate: "CommercialTermRuleCreate"
    };
  },
  computed: {
    ...mapState({
      lang: state => state.common.lang
    }),
     nameRoleEntity(){
      return NAME_OBJECT.financialConditionRule
    },
    title() {
      return this.pageTitle(
        this.$t("Просмотр правил коммерческих условий"),
        this.$t("Создание правил коммерческих условий"),
        this.$t("Редактирование правил коммерческих условий")
      );
    }
  },
  watch: {
    lang() {
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  methods: {
    toggleModal(name) {
      this.modals[name] = !this.modals[name];
    },
    openHistory() {
      this.toggleModal("history");
    },
    closeHistory() {
      this.toggleModal("history");
      this.initData();
    },

    initData() {
      this.load = false;
      this.$store
        .dispatch(COMMERCIAL_TERMS_RULE + READ, {
          id: this.$route.params.FinancialConditionRuleId || "0",
          self: this,
          FinancialConditionId: this.$route.params.FinancialConditionId
        })
        .then(res => {
          this.loadData = res.object;
          let fieldInfoList = res.fieldInfoList;

          this.fieldInfoList = fieldInfoList; //del in future
          this.scheme.configForm = convertFieldInfoListToScheme({
            fieldInfoList,
            langFieldName: FIELD_LANG_FINANCIAL_CONDITION_RULE
          });
          this.preResult = convertFieldInfoListToScheme({
            fieldInfoList,
            langFieldName: FIELD_LANG_FINANCIAL_CONDITION_RULE
          }); //del in future

     
          this.loadData.financialConditionId = this.$route.params.FinancialConditionId
          this.load = true;
        });
    },
    saveData() {
      if (this.validateData() == false) {
        return;
      }
      let saveData = clearReactive(this.loadData);
      saveData = clearNull(saveData);
      this.wait = true;
      this.$store
        .dispatch(COMMERCIAL_TERMS_RULE + UPDATE, {
          id: this.$route.params.FinancialConditionRuleId,
          saveData: saveData,
          self: this,
          FinancialConditionId: this.$route.params.FinancialConditionId
        })
        .then(res => {
          this.wait = false;
          if (res.errors.length == 0) {
            notify(this, this.$t("Успешно"), TYPE_ERRORS.SUCCESS);
            this.$router.push({ path: this.pathBack });
          }
        })
        .catch(err => {
          console.error(err);
          this.wait = false;
        });
    }
  }
};
</script>
